module.exports = __webpack_public_path__ + "static/media/p3.d24ffd9d.svg";